import { IUserApiModel } from './api/user.api.model';

export class UserModel {
  username: string;
  name: string;
  firstName: string;
  lastName: string;
  gender: string;
  image: string;
  stars: number;
  nPublishers: number;
  nSubscribers: number;
  facebookId: string;
  achievements: Array<any>;

  constructor(source?: IUserApiModel) {
    if (source == null) {
      return;
    }

    this.username = source.username;
    this.name = source.name;
    this.firstName = source.first_name;
    this.lastName = source.last_name;
    this.gender = source.gender;
    this.image = source.image;
    this.stars = source.stars;
    this.nPublishers = source.c_publishers;
    this.nSubscribers = source.c_subscribers;
    this.facebookId = source.facebook_id;
    this.achievements = source.achievements;
  }

  static copyObj(source: Pick<UserModel, keyof UserModel>): UserModel {
    return Object.assign(new UserModel(), source);
  }
}
